import globalStatehook from './globalStatehook';

export default globalStatehook;

export { globalStatehook };

export const GLOBAL_STATEHOOK_KEY_TEMP_WORKSPACE_HELP_ALL = 'temp_workspace.help.introduction';
export const GLOBAL_STATEHOOK_KEY_TEMP_WORKSPACE_HELP_TEACHER = `${GLOBAL_STATEHOOK_KEY_TEMP_WORKSPACE_HELP_ALL}.teacher`;
export const GLOBAL_STATEHOOK_KEY_TEMP_WORKSPACE_HELP_STUDENT = `${GLOBAL_STATEHOOK_KEY_TEMP_WORKSPACE_HELP_ALL}.student`;
